import React, { useState } from 'react';
import axios from 'axios';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [isSignup, setIsSignup] = useState(false);
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
<p style={{ fontSize: 13, color: '#6b7280', marginTop: 12, textAlign: 'center' }}>
  <a href="/forgot-password" style={{ color: '#2563eb' }}>Forgot password?</a>
</p>
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const endpoint = isSignup ? '/api/auth/signup' : '/api/auth/login';
      const { data } = await axios.post('https://tribaltech-backend.onrender.com' + endpoint, { email, password });
      localStorage.setItem('tribal_token', data.token);
      localStorage.setItem('tribal_user', JSON.stringify(data.user));
      window.location.href = '/dashboard';
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ width: 400 }}>
        <div style={{ textAlign:'center', marginBottom: 32 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--purple-light)', marginBottom: 8 }}>
            CREATOR PROTECT
          </div>
          <div style={{ color: 'var(--muted)', fontSize: 14 }}>
            Content protection for creators
          </div>
        </div>

        <div className="card">
          <h2 style={{ marginBottom: 24, fontSize: 18 }}>
            {isSignup ? 'Create your account' : 'Sign in'}
          </h2>

          {error && (
            <div style={{ background:'#7F1D1D', color:'#FCA5A5', padding:'10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, color: 'var(--muted)', display:'block', marginBottom: 6 }}>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ fontSize: 13, color: 'var(--muted)', display:'block', marginBottom: 6 }}>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width:'100%' }} disabled={loading}>
              {loading ? 'Please wait...' : (isSignup ? 'Create account' : 'Sign in')}
            </button>
          </form>

          <div style={{ textAlign:'center', marginTop: 20, fontSize: 14, color: 'var(--muted)' }}>
            {isSignup ? 'Already have an account? ' : "Don't have an account? "}
            <span
              onClick={() => setIsSignup(!isSignup)}
              style={{ color: 'var(--purple-light)', cursor:'pointer' }}
            >
              {isSignup ? 'Sign in' : 'Sign up'}
            </span>
          </div>
        </div>

        <div style={{ textAlign:'center', marginTop: 20, fontSize: 12, color: 'var(--muted)' }}>
          By signing up you agree to our Terms of Service
        </div>
      </div>
    </div>
  );
}
